import { usePlat, useNumber } from '@/utils/global-attrs';

export const useGlobalAttrs = (app: any) => {

  // 平台判断
  const { plat, isPC } = usePlat();
  app.config.globalProperties.$plat = plat;
  app.config.globalProperties.$isPC = isPC;

  // 数字处理
  const { toFormat } = useNumber();
  app.config.globalProperties.$num = toFormat;
};